export const getChangePasswordUrl = (authAuthority: string, clientId: string, redirectUri: string): string => {
  const returnUrl = `/connect/authorize/callback?client_id=${clientId}&redirect_uri=${redirectUri}`;
  return `${authAuthority}/change-password?ReturnUrl=${encodeURIComponent(returnUrl)}`;
};
